import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { EnvironmentService } from '../service/service.module';
import { LocalstorageService } from '../config/localstorage.service';
import { IS_WORKER, USER_ID } from '@algomusinc/domain';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  environment = EnvironmentService.environment;
  sub!: PushSubscription | any;
  constructor(
    // private swPush: SwPush ,
     private http: HttpClient,  public storage: LocalstorageService) {
    this.checkRegisteredUser();
    //this.checkVersion();
    this.listen();
  }
  subscribeNotifications(sub: any) {
    return this.http.post<any>(`${this.environment.WebPush}/subscribe`, sub);
  }
  unsubscribeNotifications(sub: any) : Observable<any>{
    return this.http.post<any>(`${this.environment.WebPush}/unsubscribe`, sub);
  }
  send() {
    return this.http.post(`https://localhost:7181/api/PushNotification/newsletter`, null);
  }


  /*
  This method will get all the notifications send by the backend
  waiting in the browser and will display them.
*/
  listen() {
    // this.swPush.messages.subscribe((res: any) => {
    //   console.log('[App] Push message received', res);
    //  // this.notifyMe(res);
    // })
  }
  notifyMe(notification: Notification) {
    console.log(Notification.permission)
    if (Notification.permission !== 'granted')
      Notification.requestPermission();
    else {
      var notification = new Notification(notification.title, {
        icon: notification.icon,
        body: notification.body,
      });
      notification.onclick = function () {
        window.open('https://alpha-dev-portal.algoplus.com/');
      };
    }
  }


  /*
    This method will subscribe user for the notifications
    it will hit an api and will send an object containing an endpoint, and two keys.
    backend will get the object and will pass notification to web push api which
    will eventually send notification on the endpoint.
  */
  subscribe() {
    // if (this.swPush.isEnabled) {
    //   this.swPush.requestSubscription({
    //     serverPublicKey: this.environment.VapidPublicKey
    //   })
    //     .then((sub: any) => {
    //       let pushSubscription = {
    //         endpoint: sub.endpoint,
    //         p256dh: sub.toJSON().keys.p256dh,
    //         auth: sub.toJSON().keys.auth,
    //         subscribedByUserId: this.storage.get(USER_ID)
    //       };
    //       this.setRegisteredUserInfo(pushSubscription);
    //       console.log("Notification Subscription: ", sub);
    //       this.subscribeNotifications(pushSubscription).subscribe({
    //         next: (res: any) => {
    //           console.log('Sent push subscription object to server.');
    //         },
    //         error: (err: any) => {
    //           console.log('Could not send subscription object to server, reason: ', err)
    //         }
    //       });
    //     })
    //     .catch(err => {
    //       console.error("Could not subscribe to notifications", err)
    //     });
    // }
  }

  async unsubscribe(){
  //   if (this.swPush.isEnabled) {

  // const response = await firstValueFrom(this.unsubscribeNotifications(this.sub))
  // if(response){
  //   this.swPush.unsubscribe();
  //       this.storage.remove(IS_WORKER);
  //       this.sub = null
  // }

  // }
  }
  /*
   It's just a custom method which will trigger an api
   and backend will send a notification
  */
  sendNewsletter() {
    console.log("Sending Newsletter to all Subscribers ...");
    this.send().subscribe();
  }


  setRegisteredUserInfo(obj: any) {
    this.sub = obj;
    this.storage.set(IS_WORKER, JSON.stringify(this.sub))
  }

  checkRegisteredUser() {
    let user = JSON.parse(this.storage.get(IS_WORKER)!);
    if (user) {
      this.sub = user;
    }
  }

}


